import {
    addIndex,
    adjust,
    curry,
    fromPairs,
    map,
    toPairs,
    replace,
    pipe,
    concat,
    __
} from 'ramda';

export const mapIndexed = addIndex(map);

export const mapObjectKeys = curry((fn, obj) =>
    fromPairs(map(adjust(fn, 0), toPairs(obj)))
);

export const formatNumber = pipe(String, replace(/\B(?=(\d{3})+(?!\d))/g, " "));

export const formatMoney = pipe(formatNumber, concat(__, ' ₽'));



// WEBPACK FOOTER //
// ./src/utils/ramdaAdditions.js